module.exports = __webpack_public_path__ + "static/media/kardapen-mobile.6369c3cc.svg";